// extracted by mini-css-extract-plugin
module.exports = {"button":"close-button_button__0ETur"};